import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { Row, Form, Modal } from "reactstrap";
import Select from "react-select";

// editor
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {
  assingOptions,
  cityOptions,
  colourStyles,
  countryOptions,
  locationOptions,
  stateOptions,
  statusOptions,
} from "common/utils/ComonOptions";
import configure from "configure";
import axios from "axios";
import { useParams } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const ViewLead = ({ id, LeadStatus }) => {
  const [loading, setLoading] = useState(false);

  const [allData, setAllData] = useState([]);
  const [status, setStatus] = useState("");
  const [company_name, setCompany_name] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [description, setDescription] = useState("");
  const [person_details, setPerson_details] = useState([]);

  const [allcountry, setallcountry] = useState([]);

  useEffect(() => {
    fetchLeadData();
    fetchCountry();
  }, []);

  const fetchLeadData = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/leads/${id}`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        let leadsData = res.data.lead;
        // console.log("View Lead Data", leadsData)
        // console.log("Raw person_details:", leadsData.person_details);

        setStatus(
          LeadStatus.filter((item) => item?.value == leadsData?.status)[0]
            ?.label || " - "
        );
        setCompany_name(leadsData?.company || " - ");
        setWebsite(leadsData?.website || " - ");
        setEmail(leadsData?.email || " - ");
        setPhone(leadsData?.phonenumber || " - ");
        setCountry(leadsData?.country || " - ");
        fetchState(leadsData?.country , leadsData?.state);
        fetchCity(leadsData?.state , leadsData?.city);
        setAddress(leadsData?.address || " - ");
        setPincode(leadsData?.zip || " - ");
        setDescription(leadsData?.description || " - ");
        setPerson_details(
          Array.isArray(leadsData.person_details)
            ? leadsData.person_details
            : JSON.parse(leadsData.person_details || "[]")
        );
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const fetchCountry = async () => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "get",
        url: `${configure.apiUrl}/all/countries`,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        setallcountry(res?.data?.countries);
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const fetchState = async (id , state) => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/states`,
        data : {
          country_id : id
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        setLoading(false);
        setState(res?.data?.states.filter(item => item?.id == state)[0]?.name);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const fetchCity = async (id , city) => {
    setLoading(true);
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios({
        method: "post",
        url: `${configure.apiUrl}/all/cities`,
        data :{
          state_id : id
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then((res) => {
        setCity(res?.data?.cities?.filter(item => item?.id == city)[0]?.value || "-");
        setLoading(false);
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="">
        <Container fluid>
          <Row className="px-1">
            <Form>
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="col-md-6 mb-3">
                  <h5 className="mb-3">Lead Information</h5>
                </div>

                {/* Lead Information  */}
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <label htmlFor="">
                      Status <span className="text-danger">*</span>{" "}
                    </label>
                    <input
                      type="text"
                      disabled
                      className="form-control"
                      value={status}
                    ></input>
                  </div>
                </div>
              </Row>

              {/* Company info */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Company Information</h5>
                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Company Name</label>

                  <input
                    disabled
                    type="text"
                    placeholder="Enter Company Name"
                    className="form-control "
                    value={company_name}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Website</label>
                  <input
                    type="text"
                    disabled
                    placeholder="Enter Website"
                    className="form-control "
                    value={website}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Email Address</label>
                  <input
                    type="email"
                    disabled
                    placeholder="Enter Email Address"
                    className="form-control "
                    value={email}
                  />
                </div>

                <div className="col-md-4 mt-2 mb-3 mb-md-0 mt-3">
                  <label htmlFor="">Phone</label>
                  <input
                    type="text"
                    disabled
                    placeholder="Enter Phone"
                    className="form-control "
                    value={phone}
                  />
                </div>
                {/* <Row>
                      <div className="col-md-4 mt-2 mb-3 mb-md-0 mt-3">
                        <label htmlFor="">Email Address</label>
                        <input
                          type="email"
                          onChange={e => setEmail(e.target.value)}
                          defaultValue={email}
                          placeholder="Enter Email Address"
                          className="form-control "
                        />
                      </div>
                      <div className="col-md-4 mt-2 mb-3 mb-md-0 mt-3">
                        <label htmlFor="">Phone</label>
                        <input
                          type="text"
                          placeholder="Enter Phone"
                          value={phone}
                          onChange={e => {
                            const enteredValue = e.target.value
                            if (/^[0-9+]*$/.test(enteredValue)) {
                              setPhone(enteredValue) // Update state if valid
                            } 
                          }}
                          className="form-control "
                        />
                      </div>
                    </Row> */}
              </Row>

              {/* Address */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Address</h5>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    Country <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={allcountry.filter(item => item?.id == country)[0]?.name}
                  ></input>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    State <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={state}
                  ></input>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="">
                    City <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    value={city}
                  ></input>
                </div>
                <div className="col-md-8 mb-3 mt-2">
                  <label htmlFor="">Address</label>
                  <input
                    type="text"
                    disabled
                    placeholder="Enter Address"
                    className="form-control "
                    value={address}
                  />
                </div>

                <div className="col-md-4 mb-3 mt-2">
                  <label htmlFor="">Pin Code</label>
                  <input
                    type="text"
                    disabled
                    placeholder="Enter Pin Code"
                    className="form-control "
                    value={pincode}
                  />
                </div>

                <div className="col-12 mt-2 lead-desc">
                  <div className="d-flex justify-space-between">
                    <label htmlFor="">
                      Description <span className="text-danger">*</span>
                    </label>
                    <span
                      className="text-danger"
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        paddingTop: "7px",
                      }}
                    ></span>
                  </div>

                  <CKEditor
                    disabled
                    editor={ClassicEditor}
                    data={description}
                    onReady={(editor) => {}}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setDescription(data);
                    }}
                  />
                </div>
              </Row>

              {/* Contact */}
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="text-dark"> Contact</h5>
                  {/* <div className="text-end mb-3">
                        <a
                          onClick={e => {
                            e.preventDefault()
                            onAddFormRow()
                          }}
                          className="btn btn-save btn-label"
                        >
                          <i className="fas fa-plus me-2 label-icon"></i>
                          Add More
                        </a>
                      </div> */}
                </div>
                {person_details.map((person, key) => (
                  <div key={person.id} className="mb-4 border-bottom pb-4">
                    <div className="d-flex">
                      <div className="col-12 contact-form d-flex gap-3 align-items-center">
                        <div className="col-4 contact-column mb-3 mb-md-0">
                          <label htmlFor="">Name</label>
                          <input
                            disabled
                            type="text"
                            name="person_name"
                            placeholder="Enter Name"
                            className="form-control "
                            value={person?.person_name || " - "}
                          />
                        </div>
                        <div className="col-4 contact-column mb-3 mb-md-0">
                          <label htmlFor="">Email</label>
                          <input
                            disabled
                            type="text"
                            name="person_email"
                            placeholder="Enter Email"
                            className="form-control "
                            value={person?.person_email || " - "}
                          />
                        </div>
                        <div className="contact-column mb-3 mb-md-0">
                          <label htmlFor="">Phone</label>
                          <input
                            disabled
                            type="text"
                            name="person_phone"
                            placeholder="Enter Number"
                            className="form-control "
                            value={person?.person_phone || " - "}
                          />
                        </div>
                        <div className="contact-column-2 mb-3 mb-md-0 d-flex gap-3">
                          <div className="text-center">
                            <label className="d-block">Authority</label>
                            <select
                              disabled
                              className="form-control"
                              name="decision_maker"
                              value={
                                person?.decision_maker == "on" ? "Yes" : "No"
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                          <div className="text-center me-2">
                            <label className="d-block">Primary</label>
                            <select
                              disabled
                              className="form-control"
                              name="chk_contact"
                              value={
                                person?.decision_maker == "true" ? "Yes" : "No"
                              }
                            >
                              <option value="No">No</option>
                              <option value="Yes">Yes</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="contact-btns pe-0 d-flex justify-content-end align-items-end mb-3 mb-md-0"></div>
                    </div>
                    <div className="row mt-4 pb-10 col-12">
                      {/* <div className="col-4 mb-3 mt-2 mb-md-0">
                            <label htmlFor="">Designation </label>
                            <input
                              disabled
                              type="text"
                              name="facebook"
                              placeholder="Enter Facebook Profile Link"
                              className="form-control "
                              value={person?.person_designation || " - "}
                            />
                          </div> */}
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">Facebook Profile Link </label>
                        <input
                          disabled
                          type="text"
                          name="facebook"
                          placeholder="Enter Facebook Profile Link"
                          className="form-control "
                          value={person?.facebook || " - "}
                        />
                      </div>
                      <div className="col-4 mb-3 mt-2 mb-md-0">
                        <label htmlFor="">LinkedIn Profile Link</label>
                        <input
                          disabled
                          type="text"
                          name="linkedin"
                          placeholder="Enter LinkedIn Profile Link"
                          className="form-control "
                          value={person?.linkedin || " - "}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </Row>
            </Form>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewLead;
